import { fetchGHGInventoryData } from '../components/charts/GHGInventorySupabase';
import type { GHGInventoryResult } from '../components/charts/ghgInventoryChartTypes';
import { fetchConsumptionBasedGHGData } from './consumptionBasedGHGService';
import { fetchInventoryComparisonData } from './inventoryComparisonService';

function slugColumn(label: string): string {
  return label
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_|_$/g, '')
    .toLowerCase();
}

export function flattenSectorGhgInventory(location: string, result: GHGInventoryResult): Record<string, unknown>[] {
  const years = result.chartData.labels as number[];
  return years.map((year, yearIndex) => {
    const row: Record<string, unknown> = { location, year };
    let total = 0;
    for (const dataset of result.chartData.datasets) {
      const value = Number(dataset.data[yearIndex]) || 0;
      row[slugColumn(dataset.label)] = value;
      total += value;
    }
    row.total_mt_co2e = total;
    return row;
  });
}

export function flattenConsumptionGhgInventory(
  location: string,
  result: Awaited<ReturnType<typeof fetchConsumptionBasedGHGData>>
): Record<string, unknown>[] {
  const years = result.chartData.labels as number[];
  return years.map((year, yearIndex) => {
    const row: Record<string, unknown> = { location, year };
    let total = 0;
    for (const dataset of result.chartData.datasets) {
      const value = Number(dataset.data[yearIndex]) || 0;
      row[slugColumn(dataset.label)] = value;
      total += value;
    }
    row.total_mt_co2e = total;
    return row;
  });
}

export function flattenInventoryComparison(
  location: string,
  result: Awaited<ReturnType<typeof fetchInventoryComparisonData>>
): Record<string, unknown>[] {
  const years = result.chartData.labels as number[];
  return years.map((year, yearIndex) => ({
    location,
    year,
    sector_based_mt_co2e: result.chartData.datasets[0]?.data[yearIndex] ?? null,
    consumption_based_mt_co2e: result.chartData.datasets[1]?.data[yearIndex] ?? null,
  }));
}

export async function loadSectorGhgInventoryDownloadRows(location: string) {
  const result = await fetchGHGInventoryData(location);
  return flattenSectorGhgInventory(location, result);
}

export async function loadConsumptionGhgInventoryDownloadRows(location: string) {
  const result = await fetchConsumptionBasedGHGData(location);
  return flattenConsumptionGhgInventory(location, result);
}

export async function loadInventoryComparisonDownloadRows(location: string) {
  const result = await fetchInventoryComparisonData(location);
  return flattenInventoryComparison(location, result);
}
